export const VKONTACTE = {
  api: 'http://vk.com/share.php',
  mod: 'vk',
  title: 'ВКонтакте',
  keys: {
    url: 'url',
    title: 'title',
    // description: 'description',
    image: 'image'
  }
};
export const FACEBOOK = {
  api: 'http://www.facebook.com/sharer.php',
  mod: 'fb',
  title: 'Facebook',
  keys: {
    url: 'u',
  }
};
export const ODNOKLASSNIKI = {
  api: 'https://connect.ok.ru/offer',
  mod: 'ok',
  title: 'Одноклассники',
  // additionalKey: 'st.cmd=addShare&st.s=1',
  keys: {
    url: 'url',
    title: 'title',
    // description: 'st.comments',
    image: 'imageUrl',
  }
};
export const TWITTER = {
  api: 'http://twitter.com/share',
  mod: 'tw',
  title: 'Twitter',
  keys: {
    url: 'url',
    title: 'text',
  }

};
export const TELEGRAM = {
  api: 'https://telegram.me/share/url',
  mod: 'tm',
  title: 'Telegram',
  keys: {
    url: 'url',
    title: 'text',
  }
};
export const WHATSAPP = {
  api: 'https://api.whatsapp.com/send',
  mod: 'wh',
  title: 'WhatsApp',
  keys: {
    messangerText: 'text',
  }
};
export const VIBER = {
  api: 'viber://forward',
  mod: 'vb',
  title: 'Viber',
  keys: {
    messangerText: 'text',
  }
};

export const SHARE_DEFAULT = [
  ['vk', VKONTACTE],
  ['fb', FACEBOOK],
  ['ok', ODNOKLASSNIKI],
  ['twitter', TWITTER],
  ['telegram', TELEGRAM],
  ['whatsapp', WHATSAPP],
  ['viber', VIBER]
];


  /*

  vk:
  http://vk.com/share.php?
  url=https://www.mk.ru/projects/komandirovka-k-maniaku/
  title=
  description=
  image=

  fb:
  http://www.facebook.com/sharer.php?
  u=https://www.mk.ru/projects/komandirovka-k-maniaku/

  og tags for all other

  ok:
  http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1
  st._surl=
  st.comments=

  tw:
  http://twitter.com/share?
  url=https://www.mk.ru/projects/komandirovka-k-maniaku/
  text=
  via=

  wh:
  https://api.whatsapp.com/send?
  text= + https://www.mk.ru/projects/komandirovka-k-maniaku/ +
  tm:
  https://telegram.me/share/url?
  url=https://www.mk.ru/projects/komandirovka-k-maniaku/
  text=

  vb:
  viber://forward?
  text= + https://www.mk.ru/projects/komandirovka-k-maniaku/ +
  */



// WEBPACK FOOTER //
// ./components/share/settings/constants.js